import config from '../../config';
import en_us from './en-us.json';
import ja_jp from './ja-jp.json';
import zh_cn from './zh-cn.json';
import th_th from './th-th.json';

const languages = () => {
  switch (config.gatsby.lang) {
    case 'en-us':
      return en_us;
    case 'ja-jp':
      return ja_jp;
    case 'zh-cn':
      return zh_cn;
    case 'th-th':
      return th_th;
    default:
      return en_us;
  }
};

export default languages();
